import { Component } from '@angular/core';
import { CargosprintLogoComponent } from '../cargosprint-logo/cargosprint-logo.component';
import { LogoOrientation } from '../types/logo-orientation.enum';
import { LogoVariant } from '../types/logo-variant.enum';

@Component({
    selector: 'app-auth-logo',
    imports: [
        CargosprintLogoComponent
    ],
    templateUrl: './auth-logo.component.html',
    styleUrl: './auth-logo.component.scss'
})
export class AuthLogoComponent {

    public LogoOrientation = LogoOrientation;
    public LogoVariant = LogoVariant;
}
